/* eslint-disable @typescript-eslint/naming-convention */

import { ReactElement } from 'react';
import classnames from 'classnames';
import { IBaseProduct } from '@Hotels-at-Home/hah-fe-core/dist/types';
import { category } from '~/constants/siteConfig';

interface SEOProps {
  product?: IBaseProduct;
}

const SEO = ({ product }: SEOProps): ReactElement => {
  const {
    seo_copy_image,
    seo_copy_image_width,
    seo_copy_image_height,
    seo_copy_image_mobile,
    seo_copy_image_width_mobile,
    seo_copy_image_height_mobile,
    seo_copy1,
    seo_copy2,
  } = product;

  if (!seo_copy1 && !seo_copy2) {
    return null;
  }

  return (
    <section
      className={classnames(
        'seo',
        'seo-padding',
        seo_copy_image_mobile ? 'has-mobile-image' : 'no-mobile-image',
      )}
    >
      <div className={classnames('seo-stack', 'seo-container seo-white-bg')}>
        <span className="icon-link" />
        <h2>{seo_copy1}</h2>
        <p>{seo_copy2}</p>
      </div>
      {seo_copy_image && (
        <div className="seo-img-wrapper">
          <picture>
            {seo_copy_image_mobile?.url && (
              <source
                data-srcset={seo_copy_image_mobile?.url}
                width={seo_copy_image_width_mobile}
                height={seo_copy_image_height_mobile}
                media="(max-width: 660px)"
              />
            )}
            <img
              alt={seo_copy1}
              width={seo_copy_image_width || category.seoImageWidth}
              height={seo_copy_image_height || category.seoImageHeight}
              src={seo_copy_image?.url}
              loading="lazy"
            />
          </picture>
        </div>
      )}
    </section>
  );
};

export default SEO;
